<template>
    <div class="container">
        <div class="black" v-show="close" @click="close = !close"></div>
        <div class="background_msg" :class="[{mode_1: checkMode1()}, {mode_2: checkMode2()}, {mode_3: checkMode3()}]" v-if="arr.length > 0" v-show="close">
            <div class="close-btn" v-show="close" @click="close = !close">&times;</div>
            <div>
                <div class="flex">
                    <img v-if='arr[index].notiCover != null && arr[index].notiCover != ""' :src="arr[index].notiCover">
                    <div class="flex_right">
                        <h1 class="title" v-if='arr[index].notiTitle != null && arr[index].notiTitle != ""'>{{arr[index].notiTitle}}</h1>
                        <div>
                        <p class="content" v-if='arr[index].notiContents != null && arr[index].notiContents != ""'>{{arr[index].notiContents}}</p>
                        </div>
                    </div>
                </div>
                <div v-if="arr.length > 1" class="btn">
                    <button @click="back()" :class="{disabled: index == 0}">Back</button>
                    <button @click="next()" :class="{disabled: index == (arr.length - 1)}">Next</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {

        name:'Message1',
        data(){
            return{
                close: false,
                index: 0,
                arr: []
            }
        },
        created () {
            this.$api
            .post("/notification/getNotification", {
                domainName: window.location.host
            })
            .then((response) => {
                if (response.data != null && response.data.length > 0) {
					this.arr = response.data.sort(function(a, b){
						return b.type - a.type;
					});
					this.close = true;
				}
            });
            
        },
        methods:{
            // button prev 
            back: function () {
                if (this.index == 0) return;
                this.index -= 1;
            },

             // button next
            next: function () {
                if (this.index == (this.arr.length - 1)) return;
                this.index += 1;
            },

            checkMode1: function () {
                if (this.isNotEmpty(this.arr[this.index].notiTitle) && this.isNotEmpty(this.arr[this.index].notiContents) && !this.isNotEmpty(this.arr[this.index].notiCover)) {
                    return true;
                }
                return false;
            },

            checkMode2: function () {
                if (!this.isNotEmpty(this.arr[this.index].notiTitle) && !this.isNotEmpty(this.arr[this.index].notiContents) && this.isNotEmpty(this.arr[this.index].notiCover)) {
                    return true;
                }
                return false;
            },

            checkMode3: function () {
                if (this.isNotEmpty(this.arr[this.index].notiTitle) && this.isNotEmpty(this.arr[this.index].notiContents) && this.isNotEmpty(this.arr[this.index].notiCover)) {
                    return true;
                }
                return false;
            },

            isNotEmpty: function (str) {
                if (str != null && str != "") {
                    return true;
                }
                return false;
            }
        }

    } 
</script>

<style scoped>

.disabled{
    opacity: .3;
    cursor: default;
}
.black{
    width: 100%;
    height: 100%;
    background: #0b000c73;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
}
button:hover{
    background: rgb(106, 126, 168);
}
.background_msg.mode_2 p img{
    width: 100%;
    height: 350px;
    border-radius: 10px;
}
.background_msg{
    width: 650px;
    height: 350px;
    margin: 0 auto;
    background: #f7f7f7;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 102;
    box-shadow: 0px 5px 5px 5px #0b021c61;
}
.img img{
    width: 100%;
    height: 350px;
    border-radius: 10px;
}
.close-btn{
   color: #000;
    position: absolute;
    top: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 29px;
    font-size: 35px;
    border-radius: 50%;
    cursor: pointer;
}
.background_msg.mode_1 h1.title {  
  
    text-align: center;
    margin-top: 40px;
    padding: 0px 15px;
}
.background_msg.mode_2 img{  
    width: 100%;
    height: 350px;
    border-radius: 10px;
}
.background_msg.mode_3 .flex {
    display: flex;
    width: 100%;
}
.background_msg.mode_3 .flex img {
   height: 350px;
   width: 50%;
   border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}
.background_msg.mode_3 .flex_right{
   width: 50%;
   /* position: relative; */
}
img.fullimg {
    width: 100%;
    height: 350px;
}
.background_msg.mode_3 .btn {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-161px,133px);
    z-index: 102;
    }
.background_msg.mode_3 p.content {
    font-size: 14px;
    text-align: left;
    padding: 5px 5px;
    margin-top: 10px;
    white-space: pre-wrap;
}
.background_msg.mode_3 h1 {
    text-align: center;
    margin-top: 41px;
    padding: 0px 7px;
}
.background_msg.mode_1 p.content {
    font-size: 18px;
    position: absolute;
    top: 50;
    top: 50%;
    /* height: 50%; */
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    padding: 0 15px;
    text-align: left;
    white-space: pre-wrap;
}
.btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 136px);
    text-align: center;
    width: 100%;
}
button {
    background: black;
    border: none;
    border-radius: 13px;
    padding: 8px 22px;
    color: #fff;
    margin: 0 10px;
}
.checkImgae{
    display: flex;
}
.checkImgae h1.title{
position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -118px);
    transform: translate(17%, -125px);
    text-align: center;
    font-size: 20px;
    width: 40%;
}
.checkImgae p.content{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -45px);
    transform: translate(17%, -79px);
    text-align: center;
    width: 40%;
    font-size: 15px;
}
.checkImgae .btn {
    
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, 136px);
    transform: translate(11%, 136px);
    text-align: center;
    width: 40%;

}
.checkImgae .img img{
    width: 91%;
    height: 350px;
}
@media only screen and (max-width: 666px){
   .background_msg{
    width: 492px;
    height: 350px;
    background-size: 222%;
}
.background_msg.fullimg_one1 {
    height: 450px;
}
img.fullimg[data-v-140045e2] {
    width: 100%;
    height: 245px;
}
h1.title {
    width: 100%;
    padding: 0px 20px;
}
.checkImgae{
    display: block;
    
}
.checkImgae .img img{
    width: 100%;
    height: 150px;
    
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}
.checkImgae p.content{
    -webkit-transform: translate(-50%, -45px);
    transform: translate(-50%, 78px);
    width: 100%;
    font-size: 15px;
    padding: 0px 28px;
}
.checkImgae h1.title{
    -webkit-transform: translate(-50%, -118px);
    transform: translate(-50%, 29px);
    font-size: 20px;
    width: 100%;
}
.checkImgae .btn{
    -webkit-transform: translate(-50%, 136px);
    transform: translate(-50%, 136px);
    text-align: center;
    width: 40%;
}
.btn.btn_content {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, 136px);
    transform: translate(-50%, 184px);
    text-align: center;
    width: 100%;
}
.background_msg.mode_3 .btn[data-v-140045e2] {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-126px,134px);
    z-index: 102;
}
}
@media only screen and (max-width: 498px){
   .background_msg{
    width: 396px;
    height: 350px !important;
    background-size: 222%;
}
h1.title{
    width: 100%;
    padding: 0px 20px;
    font-size: 19px;
}

.checkImgae .btn {
    -webkit-transform: translate(-50%, 136px);
    transform: translate(-50%, 184px);
    text-align: center;
    width: 100%;
}
/* .close-btn.close_time {
    display: none;
} */
p img {
    width: 100%;
    height: 270px;
}
.background_msg.fullimg_one {
    height: 270px;
}
.button_btn {
   position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, 136px);
    transform: translate(-50%, 97px);
    text-align: center;
    width: 100%;
}
.checkImgae p.content[data-v-140045e2] {
    -webkit-transform: translate(-50%, -45px);
    transform: translate(-50%, 78px);
    width: 100%;
    font-size: 15px;
    padding: 0px 10px;
}
.background_msg.mode_3 .flex[data-v-140045e2] {
    display: -webkit-box;
    display: -ms-flexbox;
    display: block;
    width: 100%;
}
.background_msg.mode_3 .flex img[data-v-140045e2][data-v-140045e2] {
    height: 239px;
    width: 100%;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 0px;
}
.background_msg.mode_3 .flex_right[data-v-140045e2] {
    width: 100%;
    position: relative;
}
.background_msg.mode_3 h1[data-v-140045e2] {
    text-align: center;
    margin-top: 15px;
    padding: 0px 20px;
}
.background_msg.mode_3 p.content[data-v-140045e2] {

    padding: 5px 15px;
}
.background_msg.mode_3 .btn[data-v-140045e2][data-v-140045e2] {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,207px);
    z-index: 102;
}
.background_msg.mode_3 {
    height: 500px;
}
}
@media only screen and (max-width: 404px){
    .background_msg{
    width: 300px;
    height: 350px;
    background-size: 320%;
}
h1.title{
    width: 100%;
    padding: 0px 20px;
    font-size: 19px;
}

.checkImgae p.content{
    -webkit-transform: translate(-50%, -45px);
    transform: translate(-50%, 67px);
    width: 100%;
    font-size: 14px;
    padding: 0px 28px;
}
.checkImgae h1.title[data-v-140045e2] {
    -webkit-transform: translate(-50%, -118px);
    transform: translate(-50%, 12px);
    font-size: 20px;
    width: 100%;
}
.background_msg.fullimg_one1[data-v-140045e2] {
    height: 484px;
}
.checkImgae .btn[data-v-140045e2] {
    -webkit-transform: translate(-50%, 136px);
    transform: translate(-50%, 201px);
    text-align: center;
    width: 100%;
}
}
@media only screen and (max-width: 305px){
    .background_msg{
    width: 250px;
    height: 350px;
    background-size: 404%;
}
h1.title{
    width: 100%;
    padding: 0px 20px;
    font-size: 19px;
}

.checkImgae h1.title {
    -webkit-transform: translate(-50%, -118px);
    transform: translate(-50%, -15px);
    font-size: 15px;
    width: 100%;
}
.checkImgae p.content {
    -webkit-transform: translate(-50%, -45px);
    transform: translate(-50%, 61px);
    width: 100%;
    font-size: 12px;
    padding: 0px 28px;
}
p img {
    width: 100%;
    height: 220px;
}
.background_msg.fullimg_one {
    height: 220px;
}
.button_btn {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, 136px);
    transform: translate(-50%, 73px);
    text-align: center;
    width: 100%;
}
.checkImgae h1.title[data-v-140045e2][data-v-140045e2] {
    -webkit-transform: translate(-50%, -118px);
    transform: translate(-50%, 14px);
    font-size: 20px;
    width: 100%;
}
.checkImgae p.content[data-v-140045e2][data-v-140045e2] {
    -webkit-transform: translate(-50%, -45px);
    transform: translate(-50%, 60px);
    width: 100%;
    font-size: 15px;
    padding: 0px 10px;
}
.background_msg.mode_1 {
    height: 450px;
}
.background_msg.mode_1 .btn{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, 136px);
    transform: translate(-50%, 178px);
    text-align: center;
    width: 100%;
}

}
</style>


// WEBPACK FOOTER //
// src/components/message/message.vue